class ModalButton extends VariantSelects {
  constructor() {
    super();
    this.modalButton = this.querySelector('button');
    this.modalButton.addEventListener('click', this.onSubmitHandler.bind(this));
  }
  
  
  onSubmitHandler(evt) {
    evt.preventDefault();
    const cardQuickBuy = evt.target.closest('card-quickbuy');
    const stickyATCBlock = evt.target.closest('sticky-atc-block');
    const mobileQuickBuy = evt.target.closest('#quick-buy-content');

    if(stickyATCBlock) {
      const label = stickyATCBlock.querySelector('.active-color');
      if(label) {
        const script = evt.target.closest('sticky-atc-block').querySelector('script[type="application/json"]');
        const labelValue = stickyATCBlock.querySelector('.active-color').innerText;
        const variantArray = JSON.parse(script.innerHTML);
        const button = evt.target.closest('sticky-atc-block').querySelector('modal-button button');
        variantArray.forEach(variant => {
          if((variant.name).includes(labelValue) && (variant.name).includes('Aucun')) {
            button.setAttribute('data-variant', variant.id);
          }
        });
      }
    } else if(cardQuickBuy) {
      const label = cardQuickBuy.querySelector('.active-color');
      if(label) {
        const labelValue = label.innerText;
        const variantArray = JSON.parse(evt.target.closest('card-quickbuy').querySelector('script').innerHTML);
        variantArray.forEach(variant => {
          if((variant.name).includes(labelValue)) {
            this.modalButton.setAttribute('data-variant', variant.id);
          }
        });
      }
    } else if(mobileQuickBuy) {
      const label = mobileQuickBuy.querySelector('.active-color');
      if(label) {
        const labelValue = label.innerText;
        const variantArray = JSON.parse(evt.target.closest('.card-quickbuy').querySelector('pdp-color-swatch script').innerHTML);
        variantArray.forEach(variant => {
          if((variant.name).includes(labelValue)) {
            this.modalButton.setAttribute('data-variant', variant.id);
          }
        });
      }
    }

    const personalisationModal = document.querySelector('personalisation-modal');
    const productUrl = this.modalButton.getAttribute('data-url');
    const productVariantId = this.modalButton.getAttribute('data-variant');

    if (personalisationModal && personalisationModal.fetchProductData) {
      document.getElementById('personalisation-modal-container').classList.add('visible');
      return personalisationModal.fetchProductData(productUrl,productVariantId); 
    } else {
      return Promise.resolve(false);
    }
  }
}

customElements.define('modal-button', ModalButton);